<template>
    <div>
        <div v-if="isTitle !== null && isTitle === true" class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{typeName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content-caption dashed">
            <span>{{typeName}}</span>
        </div>
        <div class="hint block row">
            <h4 class="title">温馨提示：</h4>
            <span>{{qualiType.desc || '无'}}</span>
        </div>
        <template v-if="showMerchtQuali">
            <el-form :model="qualiType" ref="ruleForm" class="demo-ruleForm">
                <div class="simple-form">
                    <div v-if="((qualiTypeAttr.qualiAttr.code != 'bizTermStartDate' && qualiTypeAttr.qualiAttr.code != 'bizTermEndDate') || ((qualiTypeAttr.qualiAttr.code == 'bizTermStartDate' || qualiTypeAttr.qualiAttr.code == 'bizTermEndDate') && displayBizTermTime == true))" v-for="(qualiTypeAttr,index) in qualiType.attrList" class="form-group center">
                        <div class="form-label">
                            <label :class="{required : qualiTypeAttr.required}">{{qualiTypeAttr.qualiAttr.name}}</label>
                        </div>
                        <div class="form-value" v-if="qualiTypeAttr.qualiAttr.type == 0">
                            <el-form-item v-if="qualiTypeAttr.required" :key="qualiTypeAttr.id" :prop="'attrList.'+ index +'.qualiAttrVal'" :rules="{required: true, type : 'string',message: '该属性不能为空', trigger: 'change'}">
                                <div v-if="qualiTypeAttr.qualiAttr.code == 'orgName'">
                                    <el-input class="width-2x" v-model="qualiTypeAttr.qualiAttrVal" :change="changeOrgName(qualiTypeAttr.qualiAttrVal)"></el-input>
                                </div>
                                <div v-else>
                                    <el-input  class="width-2x" v-model="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item v-else>
                                <div v-if="qualiTypeAttr.qualiAttr.code == 'realMerchantCode'">
                                    <el-input placeholder="请输入实体集团代码" v-model="qualiTypeAttr.qualiAttrVal" class="width-2x" @input="realMerchantCodeInput">
                                        <el-button slot="append" icon="el-icon-search" @click="getRealMerchantCode(qualiTypeAttr.qualiAttrVal)"></el-button>
                                    </el-input>
                                </div>
                                <div v-else-if="qualiTypeAttr.qualiAttr.code == 'realComCode'">
                                    <el-input placeholder="请输入实体公司代码" v-model="qualiTypeAttr.qualiAttrVal" class="width-2x" @input="realComCodeInput">
                                        <el-button slot="append" icon="el-icon-search" @click="getRealComCode(qualiTypeAttr.qualiAttrVal)"></el-button>
                                    </el-input>
                                </div>
                                <div v-else>
                                    <el-input  class="width-2x" v-model="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="form-value width-2x" v-if="qualiTypeAttr.qualiAttr.type == 1">
                            <el-form-item v-if="qualiTypeAttr.required" :key="qualiTypeAttr.id" :prop="'attrList.'+ index +'.qualiAttrVal'" :rules="{required: true, type : 'string', message: '该属性不能为空', trigger: 'change'}">
                                <el-input v-model="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled" type="textarea"></el-input>
                            </el-form-item>
                            <el-form-item v-else>
                                <el-input v-model="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled" type="textarea"></el-input>
                            </el-form-item>
                        </div>
                        <div class="form-value width-2x" v-if="qualiTypeAttr.qualiAttr.type == 2">
                            <el-form-item v-if="qualiTypeAttr.required && qualiTypeAttr.qualiAttr.code == 'registCapital'" :key="qualiTypeAttr.id" :prop="'attrList.'+ index +'.qualiAttrVal'" :rules="{validator : validators.validCapital, trigger: 'change'}">
                                <el-input v-model.number="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled" type="number" min="0" placeholder="请输入数字"></el-input>
                            </el-form-item>
                            <el-form-item v-else-if="qualiTypeAttr.required" :key="qualiTypeAttr.id" :prop="'attrList.'+ index +'.qualiAttrVal'" :rules="{validator : validators.validNumber, trigger: 'blur'}">
                                <el-input v-model.number="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled" type="number" min="0" placeholder="请输入数字"></el-input>
                            </el-form-item>
                            <el-form-item v-else>
                                <el-input v-model.number="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled" type="number" min="0" placeholder="请输入数字"></el-input>
                            </el-form-item>
                        </div>
                        <div class="form-value width-2x" v-if="qualiTypeAttr.qualiAttr.type == 3">
                            <el-form-item v-if="qualiTypeAttr.required" :key="qualiTypeAttr.id" :prop="'attrList.'+index+'.qualiAttrVal'" :rules="{required: true, type : 'date', message: '该属性不能为空', trigger: 'change'}">
                                <el-date-picker v-model="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled" type="date" placeholder="选择日期"></el-date-picker>
                            </el-form-item>
                            <el-form-item v-else>
                                <el-date-picker v-model="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled" type="date" placeholder="选择日期"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="form-value width-3x" v-if="qualiTypeAttr.qualiAttr.type == 4">
                            <el-form-item v-if="qualiTypeAttr.required" :prop="'attrList.'+index+'.qualiAttrVal'" :rules="{validator : validators.validRadio, trigger: 'change'}">
                                <div v-if="qualiTypeAttr.qualiAttr.code == 'bizTermType'">
                                    <el-radio-group @change="bizTermTypeChange" v-model.number="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled">
                                        <el-radio v-for="option in qualiTypeAttr.qualiAttrOptionList" :label="option.value">{{option.text}}</el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-else-if="qualiTypeAttr.qualiAttr.code=='integratedFlag'">
                                    <el-radio-group @change="isIntegratedChange" v-model.number="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled">
                                        <el-radio v-for="option in qualiTypeAttr.qualiAttrOptionList" :label="option.value">{{option.text}}</el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-else>
                                    <el-radio-group v-model.number="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled">
                                        <el-radio v-for="option in qualiTypeAttr.qualiAttrOptionList" :label="option.value">{{option.text}}</el-radio>
                                    </el-radio-group>
                                </div>
                            </el-form-item>
                            <el-form-item v-else>
                                <div v-if="qualiTypeAttr.qualiAttr.code == 'bizTermType'">
                                    <el-radio-group @change="bizTermTypeChange" v-model.number="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled">
                                        <el-radio v-for="option in qualiTypeAttr.qualiAttrOptionList" :label="option.value">{{option.text}}</el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-else-if="qualiTypeAttr.qualiAttr.code=='integratedFlag'">
                                    <el-radio-group @change="isIntegratedChange" v-model.number="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled">
                                        <el-radio v-for="option in qualiTypeAttr.qualiAttrOptionList" :label="option.value">{{option.text}}</el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-else>
                                    <el-radio-group v-model.number="qualiTypeAttr.qualiAttrVal" :disabled="qualiTypeAttr.qualiAttrDisabled">
                                        <el-radio v-for="option in qualiTypeAttr.qualiAttrOptionList" :label="option.value">{{option.text}}</el-radio>
                                    </el-radio-group>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="form-value checkbox-space" v-if="qualiTypeAttr.qualiAttr.type == 5">
                            <el-form-item v-if="qualiTypeAttr.required" :prop="'attrList.'+index+'.qualiAttrVal'" :rules="{validator : validators.validCheckbox, trigger: 'change'}">
                                <el-checkbox-group v-model="qualiTypeAttr.qualiAttrVal">
                                    <el-checkbox v-for="option in qualiTypeAttr.qualiAttrOptionList" :label="option.value">{{option.text}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-else>
                                <el-checkbox-group v-model="qualiTypeAttr.qualiAttrVal">
                                    <el-checkbox v-for="option in qualiTypeAttr.qualiAttrOptionList" :label="option.value">{{option.text}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                        <div class="form-value" v-if="qualiTypeAttr.qualiAttr.type == 6">
                            <div class="file-area clearfix">
                                <el-form-item v-if="qualiTypeAttr.required" :prop="'attrList.'+index+'.fileItems'" :rules="{validator : validators.validTagFileItems, trigger:'change'}">
                                    <div v-if="qualiTypeAttr.qualiAttr.code == 'bizLicense'">
                                        <div style="height: auto;overflow: hidden" v-for="(fileItem, indexL21) in qualiTypeAttr.fileItems">
                                            <div v-if="integratedFlag && fileItem.tag.indexOf('（三证合一）') >= 0">
                                                <swb-file-item :trackKey="(index +'-' + indexL21)" :editable="fileItem.editable" :showTag="fileItem.showTag" :onUploaded="echoUploadedFileInfo" :tag="fileItem.tag" :fileName="fileItem.fileName" :fileUuid="fileItem.fileUuid" :fileBrowseUrl="fileItem.fileBrowseUrl" :fileDownloadUrl="fileItem.fileDownloadUrl"></swb-file-item>
                                                <a class="swb-btn-link" v-if="qualiTypeAttr.qualiAttr.code == 'bizLicense'" @click="getBizLicenseOcrResult(fileItem.fileUuid)">识别{{fileItem.tag}}</a>
                                            </div>
                                            <div v-if="!integratedFlag && fileItem.tag.indexOf('（三证合一）') < 0">
                                                <swb-file-item :trackKey="(index +'-' + indexL21)" :editable="fileItem.editable" :showTag="fileItem.showTag" :onUploaded="echoUploadedFileInfo" :tag="fileItem.tag" :fileName="fileItem.fileName" :fileUuid="fileItem.fileUuid" :fileBrowseUrl="fileItem.fileBrowseUrl" :fileDownloadUrl="fileItem.fileDownloadUrl"></swb-file-item>
                                                <a class="swb-btn-link" v-if="qualiTypeAttr.qualiAttr.code == 'bizLicense'" @click="getBizLicenseOcrResult(fileItem.fileUuid)">识别{{fileItem.tag}}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div style="height: auto;overflow: hidden" v-for="(fileItem, indexL21) in qualiTypeAttr.fileItems">
                                            <swb-file-item :trackKey="(index +'-' + indexL21)" :editable="fileItem.editable" :showTag="fileItem.showTag" :onUploaded="echoUploadedFileInfo" :tag="fileItem.tag" :fileName="fileItem.fileName" :fileUuid="fileItem.fileUuid" :fileBrowseUrl="fileItem.fileBrowseUrl" :fileDownloadUrl="fileItem.fileDownloadUrl"></swb-file-item>
                                            <a class="swb-btn-link" v-if="qualiTypeAttr.qualiAttr.code == 'bizLicense'" @click="getBizLicenseOcrResult(fileItem.fileUuid)">识别{{fileItem.tag}}</a>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item v-else>
                                    <div v-if="qualiTypeAttr.qualiAttr.code == 'bizLicense'">
                                        <div style="height: auto;overflow: hidden" v-for="(fileItem, indexL21) in qualiTypeAttr.fileItems">
                                            <div v-if="integratedFlag && fileItem.tag.indexOf('（三证合一）') >= 0">
                                                <swb-file-item :trackKey="(index +'-' + indexL21)" :editable="fileItem.editable" :showTag="fileItem.showTag" :onUploaded="echoUploadedFileInfo" :tag="fileItem.tag" :fileName="fileItem.fileName" :fileUuid="fileItem.fileUuid" :fileBrowseUrl="fileItem.fileBrowseUrl" :fileDownloadUrl="fileItem.fileDownloadUrl"></swb-file-item>
                                                <a class="swb-btn-link" v-if="qualiTypeAttr.qualiAttr.code == 'bizLicense'" @click="getBizLicenseOcrResult(fileItem.fileUuid)">识别{{fileItem.tag}}</a>
                                            </div>
                                            <div v-if="!integratedFlag && fileItem.tag.indexOf('（三证合一）') < 0">
                                                <swb-file-item :trackKey="(index +'-' + indexL21)" :editable="fileItem.editable" :showTag="fileItem.showTag" :onUploaded="echoUploadedFileInfo" :tag="fileItem.tag" :fileName="fileItem.fileName" :fileUuid="fileItem.fileUuid" :fileBrowseUrl="fileItem.fileBrowseUrl" :fileDownloadUrl="fileItem.fileDownloadUrl"></swb-file-item>
                                                <a class="swb-btn-link" v-if="qualiTypeAttr.qualiAttr.code == 'bizLicense'" @click="getBizLicenseOcrResult(fileItem.fileUuid)">识别{{fileItem.tag}}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div style="height: auto;overflow: hidden" v-for="(fileItem, indexL21) in qualiTypeAttr.fileItems">
                                            <swb-file-item :trackKey="(index +'-' + indexL21)" :editable="fileItem.editable" :showTag="fileItem.showTag" :onUploaded="echoUploadedFileInfo" :tag="fileItem.tag" :fileName="fileItem.fileName" :fileUuid="fileItem.fileUuid" :fileBrowseUrl="fileItem.fileBrowseUrl" :fileDownloadUrl="fileItem.fileDownloadUrl"></swb-file-item>
                                            <a class="swb-btn-link" v-if="qualiTypeAttr.qualiAttr.code == 'bizLicense'" @click="getBizLicenseOcrResult(fileItem.fileUuid)">识别{{fileItem.tag}}</a>
                                        </div>
                                    </div>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-value width-2x" v-if="qualiTypeAttr.qualiAttr.type == 7">
                            <el-form-item v-if="qualiTypeAttr.required">
                                <swb-region :item="addressVal" :required="true" ref="swb_region"></swb-region>
                                <el-input v-model="street"></el-input>
                            </el-form-item>
                            <el-form-item v-else>
                                <swb-region :item="addressVal" :required="false" ref="swb_region"></swb-region>
                                <el-input v-model="street"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>
        </template>
    </div>
</template>

<script>
    import { Utils, H5file } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'
    import merchtQualiApi from '../../api/merchtQuali'

    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);
    //
    import SwbRegion from '../comn/Region';
    Vue.regist(SwbRegion);

    // 对于文件的TrackKey处理
    function parseFileTrackKey(trackKey) {
        let parts = trackKey.split('-');
        return {
            index: parts[0],
            fileIndex: parts[1]
        };
    }

    export default {
        name: 'swb-merchant-quali-edit',
        desc: '资质信息编辑-公用组件',
        props: {
            qualiTypeId: {
                type: Number,
                default: null,
            },
            merchantId: {
                type: Number,
                default: null,
            },
            isTitle: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            //校验
            let validators = {
                validTagFileItems: function (rule, value, callback) {
                    let fileItems = value || [];
                    let hasValidFile = fileItems.any(function (fileItem, index) {
                        return fileItem && !Utils.isNoB(fileItem.fileUuid);
                    });
                    if(hasValidFile) {
                        callback();
                    }
                    else {
                        callback(new Error('请上传图片'));
                    }
                },
                validNumber: function (rule, value, callback) {
                    if(!Utils.isNaturalStr(value, true)) {
                        callback(new Error('请填写大于0的整数'));
                    } else {
                        callback();
                    }
                },
                validCapital: function (rule, value, callback) {
                    if(!Utils.isMoneyStr(value, true)) {
                        callback(new Error('请填写正确的金额'));
                    } else {
                        callback();
                    }
                },
                validRadio: function (rule, value, callback) {
                    if(Utils.isNoB(value)) {
                        callback(new Error('请选择'));
                    } else {
                        callback();
                    }
                },
                validCheckbox: function (rule, value, callback) {
                    if(Utils.isNoB(value)) {
                        callback(new Error('请选择'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                validators,
                qualiType: { // 基础资质类型
                    attrList: [],
                    code: null,
                },
                typeName: null,
                merchantQuali: { // 商户资质信息
                    merchantQualiAttrValList: [],
                },
                required: 0, // 是否必须
                enrollFiles: [], // 文件信息
                addressVal: {},//地址回显对象
                street: null, // 地址信息
                //
                showMerchtQuali: false, // 待数据完整后，渲染界面
                displayBizTermTime: true,
                integratedFlag: true,
            }
        },

        created: function () {
            //
            if(!Utils.isNoB(this.qualiTypeId)) {
                this.getApplyMerchantQuali();
            }
        },
        watch: {
            qualiTypeId: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    this.getApplyMerchantQuali();
                }
            }
        },
        methods: {
            bizTermTypeChange: function (value) {
                if(value == 0) {
                    this.displayBizTermTime = true;
                } else {
                    this.displayBizTermTime = false;
                    let qualiAttrList = this.qualiType.attrList;
                    for(let i = 0; i < qualiAttrList.length; i++) {
                        var qualiTypeAttr = qualiAttrList[i];
                        var code = qualiTypeAttr.qualiAttr.code;
                        if(code == "bizTermStartDate" || code == "bizTermEndDate") {
                            qualiTypeAttr.qualiAttrVal = null;
                        }
                    }
                    this.qualiType = merge({}, this.qualiType);
                }
            },
            isIntegratedChange: function (value) {
                let integratedFlag = false;
                if(value == 0) {
                    integratedFlag = false;
                } else {
                    integratedFlag = true;
                }
                if(integratedFlag != this.integratedFlag) {
                    this.integratedFlag = integratedFlag;
                    //
                    let qualiType = this.qualiType;
                    for(let i = 0; i < qualiType.attrList.length; i++) {
                        let fileTagItemsList = [];
                        let qualiTypeAttr = qualiType.attrList[i];
                        if(qualiTypeAttr.qualiAttr.code == "bizLicense") {
                            let fileItems = [];
                            let fileTags = qualiTypeAttr.fileTags;
                            // qualiTypeAttr.fileTags = fileTags;
                            for(let k = 0; k < fileTags.length; k++) {
                                let tag = fileTags[k];
                                let fileItem = {};
                                fileItem.editable = true;
                                fileItem.showTag = true;
                                fileItem.deletable = true;
                                fileItem.fileName = '';
                                fileItem.fileUuid = '';
                                fileItem.fileBrowseUrl = '';
                                fileItem.tag = tag;
                                fileItems.push(fileItem);
                            }
                            qualiTypeAttr.fileTagItemsList = merge([], fileTagItemsList);
                            qualiTypeAttr.fileItems = merge([], fileItems);
                            this.qualiType = merge({}, qualiType);
                            break;
                        }
                    }
                }
            },
            // ================================ 文件处理 ================================
            echoUploadedFileInfo(fileInfo){
                let indexInfo = parseFileTrackKey(fileInfo.trackKey);
                let index = indexInfo.index;
                let fileIndex = indexInfo.fileIndex;
                let qualiTypeAttr = this.qualiType.attrList[index];
                qualiTypeAttr.fileTagItemsList[fileIndex] = fileInfo.tag + ":" + fileInfo.fileUuid + ":" + fileInfo.fileExt;
                qualiTypeAttr.fileItems[fileIndex].fileUuid = fileInfo.fileUuid;
                qualiTypeAttr.fileItems[fileIndex].fileBrowseUrl = fileInfo.fileBrowseUrl;
            },
            // =================================== 获得原始数据 ==================================
            getQualiAttrList: function () {
                let self = this;
                let postData = {};
                postData.typeId = self.qualiTypeId || null;
                let loading = MsgBox.loading();
                merchtComnApi.getQualiType(postData, function (result) {
                    loading.close();
                    if(result.type == 'info') {
                        let qualiType = result.data;
                        for(let i = 0; i < qualiType.attrList.length; i++) {
                            let fileTagItemsList = [];
                            let qualiTypeAttr = qualiType.attrList[i];

                            let qualiAttr = qualiTypeAttr.qualiAttr;
                            if(qualiAttr.type == 5) {
                                qualiTypeAttr.qualiAttrVal = [];
                            } else if(qualiAttr.type == 6) {
                                let fileItems = [];
                                let fileTags = qualiTypeAttr.fileTags.split("|");
                                qualiTypeAttr.fileTags = fileTags;
                                for(let k = 0; k < fileTags.length; k++) {
                                    let tag = fileTags[k];
                                    let fileItem = {};
                                    fileItem.editable = true;
                                    fileItem.showTag = true;
                                    fileItem.deletable = true;
                                    fileItem.fileName = '';
                                    fileItem.fileUuid = '';
                                    fileItem.fileBrowseUrl = '';
                                    fileItem.tag = tag;
                                    fileItems.push(fileItem);
                                }
                                qualiTypeAttr.fileTagItemsList = fileTagItemsList;
                                qualiTypeAttr.fileItems = fileItems;
                            } else {
                                if(qualiAttr.code == "bizTermType") {
                                    qualiTypeAttr.qualiAttrVal = 0;
                                } else if(qualiAttr.code == "integratedFlag") {
                                    qualiTypeAttr.qualiAttrVal = 1;
                                } else {
                                    qualiTypeAttr.qualiAttrVal = null;
                                }
                            }
                            if(qualiTypeAttr.required) {
                                self.required++;
                            }
                        }
                        self.loadMineData(qualiType);
                    }
                });
            },
            // ====================================== 组装资质信息 =================================================
            loadMineData: function (qualiType) {
                //为了回显用
                let self = this;
                let merchantQuali = this.merchantQuali;
                let merchantQualiAttrValList = merchantQuali.merchantQualiAttrValList;
                if(merchantQualiAttrValList != null && merchantQualiAttrValList.length > 0) {
                    if(qualiType.attrList != null && qualiType.attrList.length > 0) {
                        for(let i = 0; i < merchantQualiAttrValList.length; i++) {
                            let merchantQualiAttrVal = merchantQualiAttrValList[i];
                            for(let j = 0; j < qualiType.attrList.length; j++) {
                                let qualiTypeAttr = qualiType.attrList[j];
                                let qualiAttr = qualiTypeAttr.qualiAttr;
                                if(merchantQualiAttrVal.qualiAttrId == qualiAttr.id) {
                                    if(qualiAttr.type == 5) {
                                        let qualiAttrValList = merchantQualiAttrVal.qualiAttrVal;
                                        let qualiAttrVal = qualiAttrValList.split("|");
                                        qualiTypeAttr.qualiAttrVal = qualiAttrVal;
                                    } else if(qualiAttr.type == 2) {
                                        qualiTypeAttr.qualiAttrVal = parseInt(merchantQualiAttrVal.qualiAttrVal);
                                    } else if(qualiAttr.type == 3) {
                                        qualiTypeAttr.qualiAttrVal = Date.parseAsDate(merchantQualiAttrVal.qualiAttrVal);
                                    } else if(qualiAttr.type == 6) {
                                        let merchantQualiFileList = merchantQualiAttrVal.merchantQualiFileList || [];
                                        let fileItems = qualiTypeAttr.fileItems;
//
                                        for(let k = 0; k < merchantQualiFileList.length; k++) {
                                            let merchantQualiFile = merchantQualiFileList[k];
                                            let fileItemIndex = fileItems.indexOf(merchantQualiFile.tag, function (tempitem, tag) {
                                                return tempitem.tag == tag;
                                            });
                                            if(fileItemIndex != -1) {
                                                let fileItem = fileItems[fileItemIndex];
                                                fileItem.fileBrowseUrl = merchantQualiFile.fileBrowseUrl;
                                                fileItem.fileUuid = merchantQualiFile.fileUuid;
                                                fileItem.fileExt = merchantQualiFile.fileExt;
                                                fileItem.fileName = merchantQualiFile.fileExt;
                                                fileItem.fileDownloadUrl = merchantQualiFile.fileDownloadUrl;
                                                //
                                                let fileTagItem = fileItem.tag + ":" + fileItem.fileUuid + ":" + fileItem.fileExt;
                                                qualiTypeAttr.fileTagItemsList[fileItemIndex] = fileTagItem;
                                                qualiTypeAttr.fileItems[fileItemIndex] = fileItem;
                                            }
                                        }
                                    } else if(qualiAttr.type == 7) {
                                        let qualiAttrVal = merchantQualiAttrVal.qualiAttrVal;
                                        if(qualiAttrVal != null) {
                                            let qualiAttrVals = qualiAttrVal.split(",");
                                            let addressVal = {};
                                            // 0: regionId , 4: street
                                            addressVal.provinceId = parseInt(qualiAttrVals[1]);
                                            addressVal.cityId = parseInt(qualiAttrVals[2]);
                                            addressVal.countyId = parseInt(qualiAttrVals[3]);
                                            self.street = qualiAttrVals[4];
                                            self.addressVal = addressVal;
                                        }
                                    } else if(qualiAttr.type == 4) {
                                        qualiTypeAttr.qualiAttrVal = parseInt(merchantQualiAttrVal.qualiAttrVal);
                                        if(qualiAttr.code == "integratedFlag") {
                                            if(qualiTypeAttr.qualiAttrVal == 0) {
                                                self.integratedFlag = false;
                                            }
                                        }
                                    } else {
                                        qualiTypeAttr.qualiAttrVal = merchantQualiAttrVal.qualiAttrVal;
                                    }
                                }
                            }
                        }
                    }
                }
                this.showMerchtQuali = true;
                this.qualiType = Utils.merge({}, qualiType);
                this.typeName = qualiType.name;
                return qualiType;
            },
            // ======================================== 商户保存的资质 ==================================
            getApplyMerchantQuali: function () {
                let self = this;
                let postData = {};
                postData.qualiTypeId = self.qualiTypeId || null;
                postData.merchantId = self.merchantId;
                let loading = MsgBox.loading();
                merchtQualiApi.getMerchantQualiInfoByMerchantIdAndQualiTypeId(postData, function (result) {
                    loading.close();
                    if(result.type === 'info') {
                        self.merchantQuali = result.data;
                    }
                    self.getQualiAttrList();
                })
            },
            // =============================== 返回信息 =============================
            getDlgResult: function () {
                let result = {};
                let self = this;
                if(self.required > 0) {
                    self.$refs['ruleForm'].validate(function (valid) {
                        if(valid) {
                            var qualiType = self.syncQualiType();
                            if(qualiType == null) {
                                result.type = "warn";
                                result.message = "请填写必须的信息";
                            } else {
                                result.data = qualiType;
                                result.type = "info";
                            }
                        } else {
                            result.type = "warn";
                            result.message = "请填写必须的信息";
                        }
                    });
                } else {
                    result.data = self.syncQualiType();
                    result.type = "info";
                }
                return result;
            },
            // ============================ 组装提交信息 ==============================
            syncQualiType: function () {
                let self = this;
                let qualiType = self.qualiType;
                let merchantQuali = self.merchantQuali;
                let fileItems = self.fileItems;
                let merchantQualiAttrValList = [];
                merchantQuali.qualiTypeId = self.qualiType.id;
                merchantQuali.qualiTypeName = self.typeName;
                merchantQuali.qualiKind = qualiType.kind;
                merchantQuali.validated = true;

                for(let i = 0; i < qualiType.attrList.length; i++) {
                    let merchantQualiAttrVal = {};
                    let qualiTypeAttr = qualiType.attrList[i];

                    merchantQualiAttrVal.qualiAttrId = qualiTypeAttr.qualiAttr.id;
                    merchantQualiAttrVal.required = qualiTypeAttr.required;
                    let qualiAttrValList = [];
                    if(qualiTypeAttr.qualiAttr.type == 6) {
                        merchantQualiAttrVal.fileTagItemsList = Utils.merge(null, qualiTypeAttr.fileTagItemsList);
                    } else if(qualiTypeAttr.qualiAttr.type == 5) {
                        qualiAttrValList = qualiTypeAttr.qualiAttrVal;
                    } else if(qualiTypeAttr.qualiAttr.type == 7) {
                        let result = this.$refs.swb_region[0].getDlgResult() || {};
                        if(result.type == "info" && result != null) {
                            qualiAttrValList.push(result.data.regionId);
                            qualiAttrValList.push(self.street);
                        }
                    } else if(qualiTypeAttr.qualiAttr.type == 3) {
                        if(!Utils.isNoB(qualiTypeAttr.qualiAttrVal)) {
                            qualiAttrValList.push(qualiTypeAttr.qualiAttrVal.format("yyyy-MM-dd"));
                        }
                    } else {
                        qualiAttrValList.push(qualiTypeAttr.qualiAttrVal)
                    }
                    merchantQualiAttrVal.qualiAttrValList = qualiAttrValList;
                    merchantQualiAttrValList.push(merchantQualiAttrVal);
                }

                merchantQuali.merchantQualiAttrValList = merchantQualiAttrValList;
                return merchantQuali;
            },
            // =================================== 识别营业执照 =================================
            getBizLicenseOcrResult: function (fileUuid) {
                let self = this;
                let postData = {};
                postData.uuid = fileUuid;
                let theLoad = MsgBox.loading('正在识别营业执照.....');
                merchtQualiApi.getBizLicenseOcrResult(postData, function (result) {
                    if(result != null) {
                        if(result.type == 'info') {
                            let licenseData = result.data;
                            self.licenseData = licenseData;
                            // 识别营业执照的信息回显
                            let qualiType = self.qualiType;
                            if(!Utils.isNoB(licenseData)) {
                                //
                                for(let j = 0; j < qualiType.attrList.length; j++) {
                                    let qualiTypeAttr = qualiType.attrList[j];
                                    let qualiAttr = qualiTypeAttr.qualiAttr;
                                    //
                                    switch(qualiAttr.code) {
                                        case 'orgName': {
                                            let value = licenseData.orgName;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'registNo': {
                                            let value = licenseData.registNo;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'socialCreditCode': {
                                            let value = licenseData.socialCreditCode;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'orgCode': {
                                            let value = licenseData.orgCode;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'taxRegistNo': {
                                            let value = licenseData.taxRegistNo;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'orgForm': {
                                            let value = licenseData.orgForm;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'residence': {
                                            let value = licenseData.residence;
                                            if(!Utils.isNoB(value)) {
                                                // qualiTypeAttr.qualiAttrVal = value;
                                                self.street = licenseData.residence;
                                            }
                                            break;
                                        }
                                        case 'legalPerson': {
                                            let value = licenseData.legalPerson;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'registCapital': {
                                            let value = licenseData.registCapital;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value / 10000;
                                            }
                                            break;
                                        }
                                        case 'bizScope': {
                                            let value = licenseData.bizScope;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'foundDate': {
                                            let value = licenseData.foundDate;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'bizTermStartDate': {
                                            let value = licenseData.bizTermStartDate;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'bizTermEndDate': {
                                            let value = licenseData.bizTermEndDate;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'issueDate': {
                                            let value = licenseData.issueDate;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'registCapitalStr': {
                                            let value = licenseData.registCapitalStr;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'integrated': {
                                            let value = licenseData.integrated;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        case 'bizTerm': {
                                            let value = licenseData.bizTerm;
                                            if(!Utils.isNoB(value)) {
                                                qualiTypeAttr.qualiAttrVal = value;
                                            }
                                            break;
                                        }
                                        default: {
                                            break;
                                        }
                                    }
                                }
                            }
                            self.qualiType = Utils.merge({}, qualiType);
                            Toast.show('请核对统一社会信用代码等信息是否正确');
                        } else {
                            MsgBox.warning(result.message);
                        }
                        //
                        theLoad.hide();
                    }
                });
            },
            // 商户入驻时，将orgName返回父组件
            changeOrgName: function (orgName) {
                this.$emit('sync-merchant-name', orgName);
            },
            realMerchantCodeInput(){
            },
            getRealMerchantCode(realMerchantCode){
                let self = this;
                if(Utils.isNoB(realMerchantCode)) {
                    Toast.show('请输入实体商户代码');
                    return;
                }
                let loading = MsgBox.loading();
                merchtComnApi.getRealMerchantInfoByCode({
                    code: realMerchantCode
                }, function (result) {
                    loading.close();
                    if(result.type == 'info') {
                        self.handleRealMerchant(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleRealMerchant(realMerchant){
                if(realMerchant == null) {
                    Toast.show('对应的实体商户不存在');
                    let qualiAttrList = this.qualiType.attrList;
                    for(let i = 0; i < qualiAttrList.length; i++) {
                        let qualiTypeAttr = qualiAttrList[i];
                        let code = qualiTypeAttr.qualiAttr.code;
                        if(code == "realMerchantCode") {
                            qualiTypeAttr.qualiAttrValId = null;
                        }
                    }
                } else {
                    let qualiAttrList = this.qualiType.attrList;
                    for(let i = 0; i < qualiAttrList.length; i++) {
                        let qualiTypeAttr = qualiAttrList[i];
                        let code = qualiTypeAttr.qualiAttr.code;
                        if(code == "realMerchantCode") {
                            qualiTypeAttr.qualiAttrValId = realMerchant.id;
                        }
                    }
                }
                this.qualiType = merge({}, this.qualiType);
            },
            realComCodeInput(){
            },
            getRealComCode(realComCode){
                let self = this;
                let realMerchantCode = null;
                let realMerchantId = null;
                let qualiAttrList = this.qualiType.attrList;
                for(let i = 0; i < qualiAttrList.length; i++) {
                    let qualiTypeAttr = qualiAttrList[i];
                    let code = qualiTypeAttr.qualiAttr.code;
                    if(code == "realMerchantCode") {
                        realMerchantCode = qualiTypeAttr.qualiAttrVal;
                        realMerchantId = qualiTypeAttr.qualiAttrValId;
                    }
                }
                if(Utils.isNoB(realMerchantCode)) {
                    Toast.show('请输入实体商户代码');
                    return;
                }
                if(Utils.isNoB(realComCode)) {
                    Toast.show('请输入实体公司代码');
                    return;
                }
                if(Utils.isNoB(realMerchantId)) {
                    this.handleRealCom(null);
                    return;
                }
                let loading = MsgBox.loading();
                merchtComnApi.getRealComByCode({
                    realMerchantId: realMerchantId,
                    code: realComCode
                }, function (result) {
                    loading.close();
                    if(result.type == 'info') {
                        self.handleRealCom(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleRealCom(realCom){
                let self = this;
                if(realCom == null) {
                    Toast.show('对应的实体公司不存在');
                    let qualiAttrList = this.qualiType.attrList;
                    for(let i = 0; i < qualiAttrList.length; i++) {
                        let qualiTypeAttr = qualiAttrList[i];
                        qualiTypeAttr.qualiAttrDisabled = false;
                    }
                } else {
                    let qualiAttrList = this.qualiType.attrList;
                    for(let i = 0; i < qualiAttrList.length; i++) {
                        let qualiTypeAttr = qualiAttrList[i];
                        let code = qualiTypeAttr.qualiAttr.code;
                        if(typeof realCom[code] != 'undefined') {
                            if(code == 'integratedFlag') {
                                qualiTypeAttr.qualiAttrVal = Utils.isTrue(realCom[code]) ? 1 : 0;
                                self.isIntegratedChange(qualiTypeAttr.qualiAttrVal);
                            } else {
                                qualiTypeAttr.qualiAttrVal = realCom[code];
                            }
                            qualiTypeAttr.qualiAttrDisabled = true;
                        }
                        if(code == 'bizTermType') {
                            self.bizTermTypeChange(0);
                            qualiTypeAttr.qualiAttrVal = 0;
                            qualiTypeAttr.qualiAttrDisabled = true;
                        }
                    }
                }
                this.qualiType = merge({}, this.qualiType);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/quali/MerchantQualiEdit.vue